import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";
import { useSelector } from "react-redux";
import type { RootState } from "../Services/Store";

export type ProtectedAccessRouteProps = {
  authenticationPath: string;
  accessCode: string;
  requiredPermission?: "read" | "write" | "update" | "delete";
  outlet: React.JSX.Element;
};

export default function ProtectedAccessRoute({
  authenticationPath,
  accessCode,
  requiredPermission = "read",
  outlet,
}: ProtectedAccessRouteProps) {
  const { isAuthenticated } = useAuth();
  const accessList = useSelector((state: RootState) => state.auth.access);
  const user = useSelector((state: RootState) => state.auth.user);
  const location = useLocation();
  const authLoading = useSelector((state: RootState) => state.auth.loading);

  // Wait for both user and access to be loaded
  if (authLoading || typeof user === "undefined" || typeof accessList === "undefined") {
    return <div>Loading...</div>;
  }
  // Redirect to login if not authenticated or user info is not found
  if (!isAuthenticated || user === null) {
    return <Navigate to={authenticationPath} state={{ from: location }} replace />;
  }

  const moduleAccess = accessList.find((item: any) => item.code === accessCode);
  if (!moduleAccess || moduleAccess[requiredPermission] !== true) {
    return <Navigate to="/shop" replace />;
  }

  return outlet;
}
